import {
	ChangeDetectorRef,
	Component,
Inject,	// EventEmitter,
	// Output,
} from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import {Router, ActivatedRoute, RouterLink} from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';


import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {DatePipe} from "@angular/common";
import {Fuhrlohnabrechnung} from "./fuhrlohnabrechnung.model";
import {Kernantwort} from "../../shared/response/kernantwort.model";
import {ErrorHelper} from "../../shared/error.helper";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http";

const PATH_FILE = 'app/protected/fuhrlohnabrechnung/fuhrlohnabrechnung.component.ts';
const OBJ_LNG_NAME = 'fuhrlohnabrechnung';
const BACKEND_PATH_PREFIX = 'fla';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/

@Component({
    selector: 'oase-fuhrlohnabrechnung',
    templateUrl: './fuhrlohnabrechnung.component.html',
    styleUrls: ['./fuhrlohnabrechnung.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule, RouterLink]

})
export class FuhrlohnabrechnungComponent extends Tabelle<Fuhrlohnabrechnung> {

	logprotokolls: Fuhrlohnabrechnung[] = new Array<Fuhrlohnabrechnung>();
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFuhrlohnabrechnungen: ReplaySubject<Fuhrlohnabrechnung[]> = new ReplaySubject<Fuhrlohnabrechnung[]>(1);

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		// private http: AuthHttp,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		// private _data: Data,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService,{
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/fla",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: 'abrechnungsmonat',
				DEFAULT_SORT_START: 'desc',
				extraDataForAdding: { }
			}
		);
		this.displayedColumns = ['abrechnungsmonat', 'abrechnungsnummer', 'sortierbaresrechnungsdatum', 'download'];
	}

	getApiParams() {
		return "seite";
	}

	getDownloadLink(fuhrlohnabrechnung: Fuhrlohnabrechnung) {
		// return this.authService.getAuthUrl(REST_API_BASE+Fuhrlohnabrechnung.download);
		return this.apiConfigService.REST_API_BASE()+fuhrlohnabrechnung.download;
	}

	getPdf(fuhrlohnabrechnung: Fuhrlohnabrechnung) {
		// const httpOptions = {
		// 	responseType: "blob"
		// };
		return this.http
			.get(this.getDownloadLink(fuhrlohnabrechnung), {
				responseType: "blob"
			});

	}

	download(fuhrlohnabrechnung: Fuhrlohnabrechnung) {
		this.getPdf(fuhrlohnabrechnung).subscribe((data) => {

			this.fehlerMain = null;
			let blob = new Blob([data], {type: 'application/pdf'});

			var downloadURL = window.URL.createObjectURL(blob);
			var link = document.createElement('a');
			link.href = downloadURL;
			link.target = "_blank";
			link.download = "Fuhrlohnabrechnung-"+fuhrlohnabrechnung.abrechnungsnummer+".pdf";
			link.click();
			this.markiereAlsHeruntergeladen(fuhrlohnabrechnung);

		},(error) => {

			if (error.status === 404) {
				this.fehlerMain = new Kernantwort();
				this.fehlerMain.messagehtml = this.translation.translate("fuhrlohnabrechnung.kein_datei", {"nummer": fuhrlohnabrechnung.abrechnungsnummer});
			} else {
				this.fehlerMain = ErrorHelper.handleError(error, "Fehler", this._logger, this.translation);
			}
		});
	}


	public markiereAlsHeruntergeladen(ls: Fuhrlohnabrechnung){
		this._logger.log(PATH_FILE + ' - Fuhrlohnabrechnung: ', ls);
		this.http
			.get<Fuhrlohnabrechnung>(this.REST_API + '/markiereAlsHeruntergeladen/' + ls.id)
			//
			.subscribe(
				data => {
					// this.authService.storeNewToken(data);
					this._logger.log(PATH_FILE + ' - got answer data: ', data);
					ls.heruntergeladen = data.heruntergeladen;
				},
				err => ErrorHelper.handleError(err,"Fehler beim Markieren von Herunterladen bei Fuhrlohnabrechnung",this._logger, this.translation)
			);
	}


}

